module.exports = "<button class=\"btn btn-default material-icons undo-redo\"\n        ng-click=\"$ctrl.undo()\"\n        ng-disabled=\"$ctrl.undoDisabled()\"\n        tooltip-placement=\"bottom\"\n        uib-tooltip=\"{{ 'Undo' | translate }}\">undo</button>\n<button class=\"btn btn-default material-icons undo-redo\"\n        ng-click=\"$ctrl.redo()\"\n        ng-disabled=\"$ctrl.redoDisabled()\"\n        tooltip-placement=\"bottom\"\n        uib-tooltip=\"{{ 'Redo' | translate }}\">redo</button>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/Creator/UndoRedo/undoRedo.html
// module id = 1005
// module chunks = 0